var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0095 2.85107C14.2552 2.85107 16.0757 4.67156 16.0757 6.91725C16.0757 9.16294 14.2552 10.9834 12.0095 10.9834C9.76385 10.9834 7.94336 9.16294 7.94336 6.91725C7.94336 4.67156 9.76385 2.85107 12.0095 2.85107Z",
    stroke: "white",
    strokeWidth: 1.7022
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5386 18.9382L4.72154 18.6999L5.5386 18.9382ZM6.35565 19.1765L6.75451 17.809L5.12039 17.3324L4.72154 18.6999L6.35565 19.1765ZM17.2647 17.809L17.6636 19.1765L19.2977 18.6999L18.8988 17.3324L17.2647 17.809ZM16.8226 20.2979H7.19665V22.0001H16.8226V20.2979ZM17.6636 19.1765C17.8271 19.7372 17.4066 20.2979 16.8226 20.2979V22.0001C18.5414 22.0001 19.7789 20.35 19.2977 18.6999L17.6636 19.1765ZM12.0096 13.8677C14.4425 13.8677 16.5835 15.4734 17.2647 17.809L18.8988 17.3324C18.0058 14.2705 15.1991 12.1655 12.0096 12.1655V13.8677ZM6.75451 17.809C7.43572 15.4734 9.57669 13.8677 12.0096 13.8677V12.1655C8.82016 12.1655 6.01344 14.2705 5.12039 17.3324L6.75451 17.809ZM4.72154 18.6999C4.24027 20.35 5.47782 22.0001 7.19665 22.0001V20.2979C6.61262 20.2979 6.19213 19.7372 6.35565 19.1765L4.72154 18.6999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginWhite);
export default __webpack_public_path__ + "static/media/login-white.8fad33a8af9cca810f7c313a31342d51.svg";
export { ForwardRef as ReactComponent };